"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SET_IMAGE_SLIDER = exports.SET_FAVORITE_PRODUCT = exports.SET_LAYOUT_TYPE = exports.CHANGE_DEFAULT_IMAGE = exports.SET_RELATED_ACCESSORIES = exports.SET_RELATED_PRODUCTS = exports.SET_SELECTED_PRODUCT = exports.OPEN_FILTERS = exports.UPDATE_FILTER_COUNTER = exports.SET_PIM_CONFIG = exports.SET_PEP_DICTIONARY = exports.SET_PEP_FILTERS = exports.SET_ACTIVE_PRODUCTS = exports.SELECTED_FILTERS = exports.SET_PRODUCT_LIST = void 0;
var SET_PRODUCT_LIST = 'SET_PRODUCT_LIST';
exports.SET_PRODUCT_LIST = SET_PRODUCT_LIST;
var SELECTED_FILTERS = 'SELECTED_FILTERS';
exports.SELECTED_FILTERS = SELECTED_FILTERS;
var SET_ACTIVE_PRODUCTS = 'SET_ACTIVE_PRODUCTS';
exports.SET_ACTIVE_PRODUCTS = SET_ACTIVE_PRODUCTS;
var SET_PEP_FILTERS = 'SET_PEP_FILTERS';
exports.SET_PEP_FILTERS = SET_PEP_FILTERS;
var SET_PEP_DICTIONARY = 'SET_PEP_DICTIONARY';
exports.SET_PEP_DICTIONARY = SET_PEP_DICTIONARY;
var SET_PIM_CONFIG = 'SET_PIM_CONFIG';
exports.SET_PIM_CONFIG = SET_PIM_CONFIG;
var UPDATE_FILTER_COUNTER = 'UPDATE_FILTER_COUNTER';
exports.UPDATE_FILTER_COUNTER = UPDATE_FILTER_COUNTER;
var OPEN_FILTERS = 'OPEN_FILTERS';
exports.OPEN_FILTERS = OPEN_FILTERS;
var SET_SELECTED_PRODUCT = 'SET_SELECTED_PRODUCT';
exports.SET_SELECTED_PRODUCT = SET_SELECTED_PRODUCT;
var SET_RELATED_PRODUCTS = 'SET_RELATED_PRODUCTS';
exports.SET_RELATED_PRODUCTS = SET_RELATED_PRODUCTS;
var SET_RELATED_ACCESSORIES = 'SET_RELATED_ACCESSORIES';
exports.SET_RELATED_ACCESSORIES = SET_RELATED_ACCESSORIES;
var CHANGE_DEFAULT_IMAGE = 'CHANGE_DEFAULT_IMAGE';
exports.CHANGE_DEFAULT_IMAGE = CHANGE_DEFAULT_IMAGE;
var SET_LAYOUT_TYPE = 'SET_LAYOUT_TYPE';
exports.SET_LAYOUT_TYPE = SET_LAYOUT_TYPE;
var SET_FAVORITE_PRODUCT = 'SET_FAVORITE_PRODUCT';
exports.SET_FAVORITE_PRODUCT = SET_FAVORITE_PRODUCT;
var SET_IMAGE_SLIDER = 'SET_IMAGE_SLIDER';
exports.SET_IMAGE_SLIDER = SET_IMAGE_SLIDER;